// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__6TAlG","item":"Breadcrumbs_item__mvrn5","separator":"Breadcrumbs_separator__-LBfP"};